module.exports = __webpack_public_path__ + "static/media/arrow-left.2f379879.svg";